import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IApiResponse } from '@core/interfaces/api-response.interface';
import { IStats } from '@interfaces/stats.interface';
import { ICreator } from '@pages/creators/creators.interface';
import { ICustomer } from '@pages/customers/customers.interface';
import { Observable } from 'rxjs';
import {
  TCampaignApi,
  TCampaignCopyPayload,
  TCampaignCreatePayload,
  TCampaignUpdatePayload,
} from './campaigns.interface';

@Injectable({
  providedIn: 'root',
})
export class CampaignsService {
  constructor(private readonly http: HttpClient) {}

  public getCampaigns(params: HttpParams): Observable<IApiResponse<TCampaignApi[]>> {
    return this.http.get<IApiResponse<TCampaignApi[]>>('campaigns', { params });
  }

  public getAdminCampaigns(params: HttpParams): Observable<IApiResponse<TCampaignApi[]>> {
    return this.http.get<IApiResponse<TCampaignApi[]>>('campaigns/admin', { params });
  }

  public getCreatorBriefingCampaigns(params: HttpParams): Observable<IApiResponse<TCampaignApi[]>> {
    return this.http.get<IApiResponse<TCampaignApi[]>>('campaigns/briefing', { params });
  }

  public getCreatorBriefingCampaign(briefingId: string, params?: HttpParams): Observable<TCampaignApi | undefined> {
    return this.http.get<TCampaignApi>(`campaigns/briefing/creator/${briefingId}`, { params });
  }

  public getExportCampaign(exportId: string, params?: HttpParams): Observable<TCampaignApi | undefined> {
    return this.http.get<TCampaignApi>(`campaigns/export/${exportId}`, { params });
  }

  public getCampaign(id: string, params?: HttpParams): Observable<TCampaignApi | undefined> {
    return this.http.get<TCampaignApi>(`campaigns/${id}`, { params });
  }

  public getAdminCampaign(id: string, params?: HttpParams): Observable<TCampaignApi | undefined> {
    return this.http.get<TCampaignApi>(`campaigns/admin/${id}`, { params });
  }

  public createCampaign(campaign: TCampaignCopyPayload | TCampaignCreatePayload): Observable<TCampaignApi> {
    return this.http.post<TCampaignApi>('campaigns', campaign);
  }

  public updateCampaign(id: string, campaign: TCampaignUpdatePayload): Observable<TCampaignApi> {
    return this.http.put<TCampaignApi>(`campaigns/${id}`, campaign);
  }

  public deleteCampaign(id: string): Observable<void> {
    return this.http.delete<void>(`campaigns/${id}`);
  }

  public getCampaignsStats(): Observable<IStats[]> {
    return this.http.get<IStats[]>('campaigns/stats');
  }

  public getCreators(params: HttpParams): Observable<IApiResponse<ICreator[]>> {
    return this.http.get<IApiResponse<ICreator[]>>('creators', { params });
  }

  public getCustomers(params: HttpParams): Observable<IApiResponse<ICustomer[]>> {
    return this.http.get<IApiResponse<ICustomer[]>>('customers', { params });
  }
}
